import { CommonModule, registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr-CA';
import { APP_INITIALIZER, InjectionToken, LOCALE_ID, ModuleWithProviders, NgModule } from '@angular/core';
import { FirebaseApp } from '@angular/fire/compat';
import { AngularFireModule, FIREBASE_APP_NAME } from '@angular/fire/compat';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFireFunctionsModule } from '@angular/fire/compat/functions';
import { USE_EMULATOR as USE_AUTH_EMULATOR } from '@angular/fire/compat/auth';
import { USE_EMULATOR as USE_DATABASE_EMULATOR } from '@angular/fire/compat/database';
import { USE_EMULATOR as USE_STORAGE_EMULATOR } from '@angular/fire/compat/storage';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import '@progress/kendo-angular-intl/locales/fr-CA/all';
import { load } from '@telerik/kendo-intl';
import * as calendar from 'cldr-data/main/fr-CA/ca-gregorian.json';
import * as currencies from 'cldr-data/main/fr-CA/currencies.json';
import * as dateFields from 'cldr-data/main/fr-CA/dateFields.json';
import * as numbers from 'cldr-data/main/fr-CA/numbers.json';
import * as timeZoneNames from 'cldr-data/main/fr-CA/timeZoneNames.json';
import * as currencyData from 'cldr-data/supplemental/currencyData.json';
import * as likelySubtags from 'cldr-data/supplemental/likelySubtags.json';
import * as weekData from 'cldr-data/supplemental/weekData.json';
import { DispatchersModule } from '../dispatchers.module';
import { environment } from '@spaq/configs/environment';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';

load(likelySubtags, weekData, currencyData, numbers, currencies, calendar, dateFields, timeZoneNames);

export const FIREBASE_CONFIG = new InjectionToken('FIREBASE_CONFIG');
export const LOCALE_CONFIG = new InjectionToken('LOCALE_CONFIG');

// @dynamic
@NgModule({
	imports: [
		DispatchersModule,
		BrowserAnimationsModule,
		BrowserModule,
		AngularFireMessagingModule,
		HttpClientModule,
		CommonModule,
		AngularFireDatabaseModule,
		AngularFireModule.initializeApp(environment.firebase),
		AngularFireFunctionsModule
	],
	declarations: [],
	providers: [],
	exports: [DispatchersModule]
})
export class SpaqModule {
	static forRoot(config: any): ModuleWithProviders<SpaqModule> {
		return {
			ngModule: SpaqModule,
			providers: [
				{ provide: FIREBASE_APP_NAME, useValue: 'test' },
				{ provide: LOCALE_ID, useValue: config.locale },
				...(environment.useEmulators
					? [
							{
								provide: APP_INITIALIZER,
								useFactory: (app: FirebaseApp) => () => {
									const functions: any = getFunctions(app, environment.functionsRegion);
									connectFunctionsEmulator(functions, '127.0.0.1', 5001);
									functions.emulatorOrigin = new URL(environment.backendApiUrl).origin;
								},
								deps: [FirebaseApp],
								multi: true
							}
						]
					: [])
			]
		};
	}

	constructor() {
		registerLocaleData(localeFr, 'fr-CA');
	}
}
